
export const colors = {
    COLOR_RED: [255, 0, 0],
    COLOR_ORANGE: [255, 165, 0],
    COLOR_YELLOW: [255, 255, 0],
    COLOR_GREEN: [0, 255, 0],
    COLOR_BLUE: [0, 0, 255],
    COLOR_DARK_BLUE: [0, 0, 128],
    COLOR_LIGHT_BLUE: [135, 206, 250],
    COLOR_VIBRANT_GREEN: [0, 255, 0],
    COLOR_VIBRANT_ORANGE: [252, 107, 3],
    COLOR_DARK_RED:[120, 30, 30],
    COLOR_BACKGROUND:[30, 30, 30],

}